import React from 'react';
import { useField, connect, FormikContextType } from 'formik';

import { Box, Typography } from '@material-ui/core/index';
import FilesDropzone from '../FilesDropzone';
import MultiFileDropzone from '../MultiFileDropzone';

interface Props {
  name: string,
  formik: FormikContextType<any>,
  label: string,
  fullWidth?: boolean,
  multiline?: boolean,
  rows?: number
}

const FormikMultiFilesDropzone = (props: any) => {
  // In order for this component to work correctly, the documents must be included in the formik state
  const [field, meta] = useField({ name: props.name });

  return (
    <Box>
      <Typography variant="h5">
        {props.label}
      </Typography>
      <Box mt={1}>
        <MultiFileDropzone
          {...props}
          files={field.value || []}
          setFiles={(_files: File) => {
            props.formik.setFieldValue(props.name, _files);
          }}
          documents={props.formik.values.documents}
        />
      </Box>
    </Box>
  );
};

export default connect(FormikMultiFilesDropzone);
